<script lang="ts">
    import { getCachedEntries } from "../../../api"
    import MedialibImage from "../MedialibImage.svelte"

    export let block: ContentBlockEntry

    let loading = true
    let partners: PartnerEntry[]

    getCachedEntries("partner", { _id: { $in: block.partners?.entries || [] } }).then((data) => {
        loading = true
        // set partners to data in order of block.partners.entries
        partners = block.partners?.entries.map((entry) => data.find((partner) => partner.id === entry))
        loading = false
    })
</script>

<div class="container">
    {#if loading}
        lade...
    {:else if partners?.length}
        <div class="grid gap-xl partner-grid">
            {#each partners as partner}
                <article class="partner-item white-bg border-radius-all border-radius-m vp-m hp-m">
                    <a href="{partner.url}" target="_blank" rel="nofollow">
                        {#if partner.image}
                            <figure>
                                <MedialibImage id="{partner.image}" />
                            </figure>
                        {:else}
                            {partner.name}
                        {/if}
                    </a>
                </article>
            {/each}
        </div>
    {/if}
</div>
